import { EmailTemplateAttachmentDto } from './EmailTemplateAttachmentDto';

export enum EmailTemplateType {
  CandidateEmail = 'candidate_email',
  CandidateRejection = 'candidate_rejection',
  CandidateSchedulingEmail = 'candidate_scheduling_email',
  CalendarEvent = 'calendar_event',
}

export interface EmailTemplate {
  id: number;
  name: string;
  emailTemplateReferenceId?: number;
  default: boolean;
  subject: string;
  subjectText: string;
  template: string;
  templateHtml: string;
  templateType?: EmailTemplateType;
  attachments: EmailTemplateAttachmentDto[];
}
